import React from 'react';

import { SVGPropsType } from 'src/types';

function BaselineChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M2 11.2L4.8 6.20002H6.8L7.8 3.90002L10.9 12.2L13 5.20002"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M1 8L15 8" stroke={stroke} strokeDasharray="0.8 0.8" />
        </svg>
    );
}

export default BaselineChart;
